import { memo } from 'react';

import { Plus } from '@air/next-icons';
import { Button } from '@air/primitive-button';
import { DropdownMenu, type DropdownMenuOption, renderDropdownItems } from '@air/primitive-dropdown-menu';

export type CreateDropdownButtonProps = {
  label?: string;
  options: DropdownMenuOption[];
  'data-testid'?: string;
};

export const CreateDropdownButton = memo(
  ({ label = 'Create', options, 'data-testid': dataTestId }: CreateDropdownButtonProps) => {
    if (!options.length) {
      return null;
    }

    return (
      <DropdownMenu
        className="min-w-[240px]"
        trigger={
          <Button
            appearance="filled"
            color="blue"
            size="medium"
            prefix={<Plus className="size-4" />}
            data-testid={dataTestId}
          >
            {label}
          </Button>
        }
      >
        {renderDropdownItems({ options, size: 'small' })}
      </DropdownMenu>
    );
  },
);

CreateDropdownButton.displayName = 'CreateDropdownButton';
